import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b698650&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=7b698650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b698650",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsThePageTitleSection: require('/usr/src/nuxt-app/components/elements/ThePageTitleSection.vue').default,ElementsTheError: require('/usr/src/nuxt-app/components/elements/TheError.vue').default,ElementsSkeletonsTheCorsi: require('/usr/src/nuxt-app/components/elements/skeletons/TheCorsi.vue').default,ElementsTheNotice: require('/usr/src/nuxt-app/components/elements/TheNotice.vue').default})
